import { useState, useEffect } from 'react';

const useCountdown = storageKey => {
  const [countdown, setCountdown] = useState(0);
  const [localFinishTime, setLocalFinishTime] = useState(
    localStorage.getItem(storageKey),
  );

  const isActive =
    localFinishTime && Date.now() < parseInt(localFinishTime, 10);

  const setFinishTime = readyTime => {
    localStorage.setItem(storageKey, readyTime.toString());
    // Trigger storage event manually since we're in the same window
    window.dispatchEvent(new Event('storage'));
  };

  const resetCountdown = () => {
    localStorage.removeItem(storageKey);
    setLocalFinishTime(null);
    setCountdown(0);
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const newFinishTime = localStorage.getItem(storageKey);
      setLocalFinishTime(newFinishTime);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [storageKey]);

  useEffect(() => {
    if (!localFinishTime) {
      setCountdown(0);
      return;
    }

    const updateCountdown = () => {
      const remaining = Math.max(0, parseInt(localFinishTime, 10) - Date.now());
      setCountdown(remaining);
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [localFinishTime]);

  return {
    countdown,
    isActive,
    setFinishTime,
    resetCountdown,
    formattedTime: {
      minutes: Math.floor(countdown / 60000),
      seconds: Math.floor((countdown % 60000) / 1000)
        .toString()
        .padStart(2, '0'),
    },
  };
};

export default useCountdown;
